import { useEffect } from 'react';
import { config, Country } from '../../../utils/config';
import { Validation } from '../../../utils/getValidator';
import { ZipCodeValidation } from '../../../utils/getZipCodeValidator';
import loadCdnData from '../../../utils/loadCdnData';

type ZipCodeLists = Partial<Record<Country, string[]>>;
const cachedZipCodeLists: ZipCodeLists = {};
const loadZipCodeList = async (country: Country, type: 'allow' | 'block') => {
  cachedZipCodeLists[country] = await loadCdnData<string[]>(`zip-code-${type}-lists/${config.shop}/${country}.json`);
};

export type UnresolvedZipCodeValidation = Validation & {
  allowList?: boolean;
  blockList?: boolean;
};

const useZipCodeValidation = (
  { allowList, blockList, ...otherValidation }: UnresolvedZipCodeValidation,
  selectedCountry: Country
): ZipCodeValidation => {
  const listType =
    allowList ? 'allow'
    : blockList ? 'block'
    : undefined;
  const zipCodeList = cachedZipCodeLists[selectedCountry];

  useEffect(() => {
    if (!listType || selectedCountry in cachedZipCodeLists) {
      return;
    }
    loadZipCodeList(selectedCountry, listType);
  }, [selectedCountry]);

  return {
    ...otherValidation,
    allowList: listType === 'allow' ? zipCodeList : undefined,
    blockList: listType === 'block' ? zipCodeList : undefined
  };
};

export default useZipCodeValidation;
